import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const FallbackTool: ToolComponent = ({ toolName, status }) => (
  <ChatToolBase status={status}>
    {status.type === "running" ? (
      <>
        Using <code>{toolName}</code>
      </>
    ) : (
      <>
        Used <code>{toolName}</code>
      </>
    )}
  </ChatToolBase>
);
